module.exports = __webpack_public_path__ + "img/visor-wordmark-on-dark.d7936d8f.svg";